<template>
  <div class="account-details-inner-form">
    <div class="flex flex-col gap-x-4 gap-y-5 md:gap-y-7" v-if="businessRegistration == '0'">

      <!-- Occupation and income -->
      <h3 class="registration-form-layout__block-title">{{ personPrefix + subscriptionsIncome}}</h3>
      <theme-checkboxes
        :label="subscriptionsIncome"
        class="form__radio"
        :options="subscriptionsTypeOfIncomeOptions"
        :name="`person[`+[i]+`][type_of_income][]`"
        @input="triggerWorkingForm"
        v-validate="`required|make_choice`"
        :isRequired="true"
      ></theme-checkboxes>

      <theme-radios
        v-if="income_working_state"
        :label="usersContractType"
        :name="`person[`+[i]+`][working_contract_type_id]`"
        :options="usersContractTypeOptions"
        :columnDirection="true"
        @input="triggerContractDuration"
        v-validate="`required|make_choice`"
        :isRequired="true"
      ></theme-radios>

      <div class="flex flex-col gap-x-4 gap-y-5 md:gap-y-7" v-if="showContractDuration">
        <theme-input
        :label="usersContractDuration"
        :name="`person[`+[i]+`][working_contract_duration]`"
        :placeholder="usersContractDurationPlaceholder"
        v-validate="`required|numeric`"
        :isRequired="true"
        ></theme-input>
        
        <theme-calendar
        :label="usersContractEndDate"
        :name="`person[`+[i]+`][working_contract_end_date]`"
        :placeholder="usersContractEndDatePlaceholder"
        v-validate="`required`"
        :isRequired="true"
        ></theme-calendar>
      </div>

      <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7" v-if="income_working_state || income_own_business_state">
        <theme-input
          :label="usersMonthlyIncome"
          :name="`person[`+[i]+`][income]`"
          :placeholder="'0,00'"
          :isExtraInfo="true"
          v-validate="`required|numeric`"
          :isRequired="true"
        >
        <template slot="extra-info">
          <span class="text-black">€</span>
        </template>
      </theme-input>

        <theme-input
          :label="usersOccupation"
          :name="`person[`+[i]+`][occupation]`"
          :placeholder="usersOccupationPlaceholder"
          v-validate="`required`"
          :isRequired="true"
        ></theme-input>
      </div>

      <theme-input
          v-if="income_studying_state"
          :label="usersStudy"
          :name="`person[`+[i]+`][study]`"
          :placeholder="usersStudyPlaceholder"
          v-validate="`required`"
          :isRequired="true"
      ></theme-input>

      
      <theme-radios
        :label="usersDoYouHaveGuarantorGeneral"
        :name="`person[`+[i]+`][guarantor]`"
        :options="usersDoYouHaveGuarantorOptions"
        @input="triggerGuarantorIncomeField"
      ></theme-radios>

      <theme-input
          v-if="income_guarantor_state"
          :label="usersGuarantorIncome"
          :name="`person[`+[i]+`][guarantor_income]`"
          :placeholder="usersGuarantorIncomePlaceholder"
          v-validate="`required|numeric`"
          :isRequired="true"
      ></theme-input>

      <theme-textarea
        :label="usersExtraInformationIncome"
        :name="`person[`+[i]+`][income_note]`"
        :placeholder="usersExtraInformationIncomePlaceholder"
        rows="4"
      ></theme-textarea>
    </div>

    <!-- Current living situation -->
    <h3 class="registration-form-layout__block-title">{{ personPrefix + usersLandlordDetails }}</h3>
    <theme-radios
      :name="`person[`+[i]+`][landlord_status]`"
      :options="usersLandlordOptions"
      @input="triggerLandlordType"
    ></theme-radios>

    <div class="flex flex-col gap-x-4 gap-y-5 md:gap-y-7" v-if="landlord_type_state == 'renting_property'">
      <theme-input
        :label="usersLandlordName"
        :name="`person[`+[i]+`][landlord_name]`"
        :placeholder="usersLandlordNamePlaceholder"
      ></theme-input>
      <theme-input
        :label="usersLandlordEmail"
        :name="`person[`+[i]+`][landlord_email]`"
        :placeholder="usersLandlordEmailPlaceholder"
        v-validate="`email`"
      ></theme-input>
      <theme-input
        :label="usersLandlordPhone"
        :name="`person[`+[i]+`][landlord_phone_number]`"
        :placeholder="usersLandlordPhonePlaceholder"
        v-validate="`phone_number`"
      ></theme-input>
    </div>

    
    <h3 class="registration-form-layout__block-title">{{ personPrefix + usersAddress }}</h3>

    <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7">
      <theme-input
        :name="`person[`+[i]+`][address][post_code]`"
        :ref="`person_postcode_` + i"
        :label="locales && locales.users && locales.users.post_code"
        :placeholder="subscriptionsPostCodePlaceholder"
        @blur="checkPcHn($event, i)"
        class="js-postcode"
      ></theme-input>

      <theme-input
        :label="locales && locales.users && locales.users.city"
        :name="`person[`+[i]+`][address][city]`"
        :ref="`person_city_` + i"
        :placeholder="subscriptionsCityPlaceholder"
      ></theme-input>

      <!-- district field already was in search pref form -->
      <!-- <theme-input
        :label="'Disctrict'"
        name="Disctrict"
        :placeholder="'Enter district name'"
      ></theme-input> -->

      <theme-input
        :label="locales && locales.users && locales.users.street"
        :name="`person[`+[i]+`][address][street]`"
        :ref="`person_street_` + i"
        :placeholder="subscriptionsStreetPlaceholder"
      ></theme-input>
    </div>

    <div class="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-3 md:gap-y-7">
      <theme-input
        class="js-house-number"
        :label="locales && locales.users && locales.users.house_number"
        :ref="`person_housenumber_` + i"
        :name="`person[`+[i]+`][address][house_number]`"
        :placeholder="subscriptionsHouseNumberPlaceholder"
        @blur="checkPostcodeAddress($event, i)"
      ></theme-input>

      <theme-input
        :label="subscriptionsHouseNumberAppendix"
        :name="`person[`+[i]+`][address][house_number_appendix]`"
        :placeholder="subscriptionsHouseNumberAppendixPlaceholder"
      ></theme-input>
    </div>

    <h3 class="registration-form-layout__block-title">{{ personPrefix + subscriptionsFamilyStatusTitle }}</h3>

    <div class="grid grid-cols-2 gap-x-4 gap-y-5 sm:grid-cols-4 md:gap-y-7">
      <theme-select
        class="col-span-full sm:col-span-2"
        :label="subscriptionsCivilStatus"
        :name="`person[`+[i]+`][civil_state_id]`"
        :options="subscriptionsCivilStatusOptions"
        show-zero-option="0"
      ></theme-select>

      <theme-select
        v-if="i == 0"
        :label="subscriptionsChildren"
        name="have_children"
        v-model.number="have_children_value"
        :options="subscriptionsChildrenOptions"
      ></theme-select>

      <theme-input
        v-if="have_children_value == 1"
        name="number_of_children"
        :placeholder="locales && locales.subscription && locales.subscription.number_of_children_placeholder"
        :label="locales && locales.subscription && locales.subscription.number_of_children"          
        v-validate="`required|numeric|min_value:0`"
        :isRequired="true"
      ></theme-input>

      <theme-select
        v-if="i == 0"
        :label="subscriptionsPets"
        name="have_pets"
        v-model.number="have_pets_value"
        :options="subscriptionsPetsOptions"
      ></theme-select>

      <!-- to do: remove if this filed doesn't need -->
      <!-- <theme-input
          v-if="have_pets_value == 1"
          name="number_of_pets"
          :placeholder="locales && locales.subscription && locales.subscription.number_of_pets_placeholder"
          :label="locales && locales.subscription && locales.subscription.number_of_pets"          
          v-validate="`required|numeric|min_value:0`"
          :isRequired="true"
        ></theme-input> -->
        

      <theme-input
        v-if="have_pets_value == 1"
        class="col-span-full"
        :label="locales && locales.subscription && locales.subscription.pets_note"
        name="pets_note"
        :placeholder="locales && locales.subscription && locales.subscription.pets_note_placeholder"
        v-validate="`required`"
        :isRequired="true"
      ></theme-input>
    </div>

    <h3 class="registration-form-layout__block-title">{{ personPrefix + subscriptionsExtraDetailsTitle }}</h3>

    <!-- :label="locales && locales.users && locales.users.title" -->
    <theme-radios
      :label="subscriptionsSexInputTitle"
      :name="`person[`+[i]+`][title_id]`"
      :options="subscriptionsSexOptions"
      v-validate="`required|make_choice`"
      :isRequired="true"
    ></theme-radios>

    <theme-radios
        :label="locales && locales.users && locales.users.language"
        :value="defaultLanguage"
        :name="`person[`+[i]+`][language]`"
        :options="languages"
      ></theme-radios>

    <theme-toggler
      v-if="i == 0"
      name="smoking"
      :label="locales && locales.users && locales.users.smoking"
    ></theme-toggler>
   
  </div>
</template>

<script>
import $ from "jquery";
import sweetalert from "sweetalert";
import { mapGetters, mapActions } from "vuex";

import ThemeInput from "./ThemeInput.vue";
import ThemeRadios from "./ThemeRadios.vue";
import ThemeCheckboxes from "./ThemeCheckboxes.vue";
import ThemeToggler from "./ThemeToggler.vue";
import ThemeSelect from "./ThemeSelect.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import ThemeTextarea from "./ThemeTextarea.vue";
import { locales } from "moment";

export default {

  inject: ["$validator"],
  components: {
    ThemeInput,
    ThemeCheckboxes,
    ThemeRadios,
    ThemeToggler,
    ThemeSelect,
    ThemeCalendar,
    ThemeTextarea
  },
  // data() {},
  computed: {
    ...mapGetters(["locales"]),
    businessRegistration: function() {
      return this.$store.state.registrationStep.businessRegistration;
    },
    yourTranslation() {
      return this.locales && this.locales.users && this.locales.users.your;
    },
    personTranslation() {
      return this.locales && this.locales.users && this.locales.users.person;
    },
    personPrefix: function() {
      if (this.i == '0') {
        return this.yourTranslation + " ";
      } else {
        const j = this.i + 1
        return `${this.personTranslation} ${j} `;
      }
    },

  },
  props: {
    i: {
      default: '',
      type: [String, Number]
    },
    subscriptionsIncome: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeInput: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractDurationPlaceholder: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersContractEndDatePlaceholder: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersOccupationInput: {
      default: "",
      type: String,
    },
    usersOccupationPlaceholder: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeInput: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersStudyInput: {
      default: "",
      type: String,
    },
    usersStudyPlaceholder: {
      default: "",
      type: String,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersGuarantorIncomeInput: {
      default: "",
      type: String,
    },
    usersGuarantorIncomePlaceholder: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomeInput: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsPostCode: {
      default: "",
      type: String,
    },
    subscriptionsPostCodePlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumber: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendix: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixExtra: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumberAppendixExtraPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsStreet: {
      default: "",
      type: String,
    },
    subscriptionsStreetPlaceholder: {
      default: "",
      type: String,
    },
    subscriptionsCity: {
      default: "",
      type: String,
    },
    subscriptionsCityPlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordDetails: {
      default: "",
      type: String,
    },
    usersLandlordLabel: {
      default: "",
      type: String,
    },
    usersLandlordRadio: {
      default: "",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    usersLandlordName: {
      default: "",
      type: String,
    },
    usersLandlordNamePlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordEmail: {
      default: "",
      type: String,
    },
    usersLandlordEmailPlaceholder: {
      default: "",
      type: String,
    },
    usersLandlordPhone: {
      default: "",
      type: String,
    },
    usersLandlordPhonePlaceholder: {
      default: "",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    subscriptionsSexInput: {
      default: "",
      type: String,
    },
    subscriptionsSexInputTitle: {
      default: "",
      type: String,
    },
    subscriptionsSexOptions: {
      default: () => {},
      type: Object,
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
    subscriptionsFamilyStatusTitle: {
      default: "",
      type: String,
    },
    subscriptionsCivilStatus: {
      default: "",
      type: String,
    },
    subscriptionsCivilStatusOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsChildren: {
      default: "",
      type: String,
    },
    subscriptionsChildrenOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsPets: {
      default: "",
      type: String,
    },
    subscriptionsPetsOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsExtraDetailsTitle: {
      default: "",
      type: String,
    },
    subscriptionsSmoking: {
      default: "",
      type: String,
    },
    subscriptionsIAm: {
      default: "",
      type: String,
    },
    usersAddress: {
      default: "",
      type: String,
    },
  },
  data() {
    return {
      business_registration: false,
      income_working_state: false,
      income_studying_state: false,
      income_own_business_state: false,
      income_guarantor_state: false,
      showContractDuration: false,
      landlord_type_state: this.landlordTypeState,
      have_children_value: '0',
      have_pets_value: '0',
    }
  },
  methods: {
    triggerWorkingForm: function (value) {
      this.income_working_state = false;
      this.income_studying_state = false;
      this.income_own_business_state = false;

      value.forEach((item) => {
        const state = this.subscriptionsTypeOfIncomeSlugs[item];
        if (state === "working") {
          this.income_working_state = true;
        }
        if (state === "studying") {
          this.income_studying_state = true;
        }
        if (state === "own_business") {
          this.income_own_business_state = true;
        }
      })
    },
    triggerGuarantorIncomeField: function (value) {
      value == '1' 
        ? this.income_guarantor_state = true 
        : this.income_guarantor_state = false;
    },
    triggerBusinessForm: function () {
      // do some fetch request and check if user chose business registration
    },
    triggerContractDuration: function (value) {
      const option = this.usersContractTypeAttributes[value];
      option === '1' ? this.showContractDuration = true : this.showContractDuration = false;
    },
    triggerLandlordType: function (value) {
      this.landlord_type_state = value;
    },
    checkPcHn(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var postcode = $("[name='person["+[i]+"][address][post_code]']")
          .first()
          .val();
        var house_number = $("[name='person["+[i]+"][address][house_number]']")
          .first()
          .val();
        if (postcode && postcode != "") {
          $.post(
            "/get-street-location",
            {
              postcode: postcode,
              house_number: house_number,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='person["+[i]+"][address][city]']")
                  .first()
                  .val(data.location);
                $("[name='person["+[i]+"][address][street]']")
                  .first()
                  .val(data.street);
                var ref1= 'person_street_' + i;
                var ref2= 'person_city_' + i;
                that.$refs[ref1].model= data.street;
                that.$refs[ref2].model= data.location;
              }
            },
            "json"
          );
        }
      }, 100);
    },
    checkPostcodeAddress(event, i) {
      this.validated = false;
      this.changed = true;
      var that = this;

      setTimeout(function () {
        var street = $("[name='person["+[i]+"][address][street]']")
          .first()
          .val();
        var house_number = $("[name='person["+[i]+"][address][house_number]']")
          .first()
          .val();
        var location = $("[name='person["+[i]+"][address][city]']")
          .first()
          .val();
        if (street != "" && house_number != "") {
          $.post(
            `/get-postcode-by-address`,
            {
              street: street,
              house_number: house_number,
              // need to get location value from registration form
              // location: location,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='person["+[i]+"][address][post_code]']")
                  .first()
                  .val(data.postcode);
                var ref= 'person_postcode_' + i;
                that.$refs[ref].model= data.postcode;
              }
            },
            "json"
          );
        }
      }, 100);
    },
  },
  beforeMount() {
    this.triggerBusinessForm();
  }
}
</script>


// WEBPACK FOOTER //
// resources/js/components/AccountDetailsInnerForm.vue